import React, { useState, useEffect } from "react";
import { Tabs, Badge, Tag, Empty } from "antd";
import { getInformOutLines, searchNotice, readedNotice } from "apis/notice";
import { renderTime } from "components/common";
import * as qs from "query-string";
import { Link } from "react-router-dom";
// import SysContent from "./sysContent";
import "../noticeCommon.css";
import { withUser } from "pages/context/user";

const { TabPane } = Tabs;

export default withUser(function SysNotify({ updateTopFn }) {
  const { companyid, token } = qs.parse(window.location.search);
  const [searchData, setSearchData] = useState({
    informType: "SYSTEM_INFORM",
    status: "NOT_READ",
    serviceType: null,
    page: 0,
    size: 5,
    token
  });
  const [infoData, setInfoData] = useState([]);
  const [noticeTotal, setNoticeTotal] = useState({});
  const getNoticeList = os => {
    getInformOutLines(os || searchData).then(data => {
      setNoticeTotal(data);
    });
  };
  useEffect(() => {
    getNoticeList();
  }, []);
  // 获取消息列表
  const getNoticeLists = os => {
    searchNotice(os || searchData).then(data => {
      console.log(data);
      setInfoData(data.content);
    });
  };
  useEffect(() => {
    getNoticeLists();
  }, [searchData]);
  // 读取切换
  function callbackRead(key) {
    console.log(key);
    setSearchData({
      ...searchData,
      informType: key
    });
  }
  // 根据时间判断状态
  const getTimeDomFn = (tag, all) => {
    const timestamp = new Date().getTime();
    const startTimes = new Date(all.startTime).getTime();
    const endTime = new Date(all.endTime).getTime();
    let dom = 1;
    if (all.customerTag) {
      dom = <Tag color="orange">{tag}</Tag>;
    } else if (timestamp <= startTimes) {
      dom = <Tag color="grey">未开始</Tag>;
    } else if (timestamp > endTime) {
      dom = <Tag color="grey">已结束</Tag>;
    } else {
      dom = <Tag color="blue">进行中</Tag>;
    }
    return dom;
  };
  // 判断消息通知类型并显示相应图标
  const typeIcon = sertype => {
    let typedom = "";
    if (sertype === 0) {
      typedom = (
        <img className="imgbox" src="/img/notice/mesnotice.png" alt="" />
      );
    }
    if (sertype === 1) {
      typedom = <img className="imgbox" src="/img/notice/wangluo.png" alt="" />;
    }
    if (sertype === 2) {
      typedom = <img className="imgbox" src="/img/notice/mingcha.png" alt="" />;
    }
    if (sertype === 4) {
      typedom = <img className="imgbox" src="/img/notice/diaoyan.png" alt="" />;
    }
    if (sertype === 13) {
      typedom = (
        <img className="imgbox" src="/img/notice/mianduimian.png" alt="" />
      );
    }
    if (sertype === 15) {
      typedom = (
        <img className="imgbox" src="/img/notice/mianduimian.png" alt="" />
      );
    }
    return typedom;
  };
  // 已读
  const empty = () => {
    const infoIds = infoData.map(j => {
      return j.id;
    });
    // console.log(infoIds);
    readedNotice(infoIds).then(data => {
      // console.log(data);
      getNoticeList();
      getNoticeLists();
      updateTopFn();
    });
  };
  // 跳转进入详情
  const indetail = (customDetailUrl, id) => {
    console.log(customDetailUrl, id);
    if (customDetailUrl) {
      window.location.href = customDetailUrl;
    } else {
      window.location.href = `/user/notice/more/${id}`;
    }
  };

  const getNoticeDom = type => {
    // 中间内容
    let sp = null;
    // 查看更多地址
    let footAddress = `/user/notice/sys`;
    // 系统通知
    if (type === 1) {
      sp = (
        <ul>
          {infoData.length === 0 ? (
            <div className="noData">
              <Empty />
            </div>
          ) : (
            infoData.map(i => {
              return (
                <li
                  className="intos"
                  onClick={() => indetail(i.customDetailUrl, i.id)}
                >
                  <img
                    className="imgbox"
                    src="/img/notice/sysmespng.png"
                    alt=""
                  />
                  <div className="contbox">
                    <h3 className="titles">{i.title}</h3>
                    <p className="gray">{renderTime(i.createdAt)}</p>
                  </div>
                </li>
              );
            })
          )}
        </ul>
      );
      footAddress = `/user/notice/sys`;
    }
    // 消息通知
    if (type === 2) {
      sp = (
        <ul>
          {infoData.length === 0 ? (
            <div className="noData">
              <Empty />
            </div>
          ) : (
            infoData.map(i => {
              return (
                <li
                  className="intos"
                  onClick={() => indetail(i.customDetailUrl, i.id)}
                >
                  {/* <img
                    className="imgbox"
                    src="/img/notice/sysmespng.png"
                    alt=""
                  /> */}
                  <span>{typeIcon(i.serviceType)}</span>
                  <div className="contbox">
                    <h3 className="titles">{i.title}</h3>
                    <p
                      // className="intros"
                      dangerouslySetInnerHTML={{
                        __html: i.content
                      }}
                    />
                    <p className="gray">{renderTime(i.createdAt)}</p>
                  </div>
                </li>
              );
            })
          )}
        </ul>
      );
      footAddress = `/user/notice/message`;
    }
    // 待办通知
    if (type === 3) {
      sp = (
        <ul>
          {infoData.length === 0 ? (
            <div className="noData">
              <Empty />
            </div>
          ) : (
            infoData.map(i => {
              return (
                <li
                  className="intos"
                  onClick={() => indetail(i.customDetailUrl, i.id)}
                >
                  <div style={{ width: "400px", marginTop: "10px" }}>
                    <h3
                      style={{
                        width: "300px",
                        float: "left"
                      }}
                    >
                      {i.title}
                    </h3>
                    <p style={{ width: "100px", float: "left" }}>
                      {getTimeDomFn(i.tag, i)}
                    </p>
                  </div>
                  <p className="gray">{renderTime(i.createdAt)}</p>
                </li>
              );
            })
          )}
        </ul>
      );
      footAddress = `/user/notice/dealt`;
    }
    const finnalAdds = companyid
      ? footAddress + `?companyid=${companyid}&serviceType=`
      : footAddress + `?serviceType=`;
    const oDom = (
      <div className="innerSBox">
        <div className="inner">{sp}</div>
        <div className="foot">
          <a onClick={empty}>清空</a>
          <Link to={finnalAdds}>查看更多</Link>
        </div>
      </div>
    );
    return oDom;
  };
  return (
    <div className="noticeInfoBox">
      <Tabs defaultActiveKey="SYSTEM_INFORM" centered onChange={callbackRead}>
        <TabPane
          tab={
            <Badge count={noticeTotal.systemInformsCount} offset={[10, 7]}>
              <p>系统通知</p>
            </Badge>
          }
          key="SYSTEM_INFORM"
        >
          {getNoticeDom(1)}
        </TabPane>
        <TabPane
          tab={
            <Badge count={noticeTotal.messageInformsCount} offset={[10, 7]}>
              <p>消息通知</p>
            </Badge>
          }
          key="MESSAGE_INFORM"
        >
          {getNoticeDom(2)}
        </TabPane>
        <TabPane
          tab={
            <Badge count={noticeTotal.todoInformsCount} offset={[10, 7]}>
              <p>待办通知</p>
            </Badge>
          }
          key="TODO_INFORM"
        >
          {getNoticeDom(3)}
        </TabPane>
      </Tabs>
    </div>
  );
});
